export const GET_EVENTS = 'GET_EVENTS';
export const SET_EVENTS = 'SET_EVENTS';
export const SET_EVENT = 'SET_EVENT';
export const GET_EVENT = 'GET_EVENT';
export const SET_EVENT_TECHNICIAN = 'SET_EVENT_TECHNICIAN';
export const SET_IS_CREATE_TECHNICIAN_CALENDAR = 'SET_IS_CREATE_TECHNICIAN_CALENDAR';
export const SET_USER_CALEDARS = 'SET_USER_CALEDARS';
export const GET_USER_CALEDARS = 'GET_USER_CALEDARS';